/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierResolver
 */
export interface CourierResolver {
    /**
     * 
     * @type {string}
     * @memberof CourierResolver
     */
    realm?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierResolver
     */
    adminUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierResolver
     */
    customerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierResolver
     */
    marketingUrl?: string;
    /**
     * Optional override for the WebAuthn Relying-Party ID. Blank means
     * passkeys are scoped to the registrable domain (eTLD+1) of the request
     * origin, so one passkey covers both the admin and customer apps.
     * @type {string}
     * @memberof CourierResolver
     */
    passkeyRpId?: string;
    /**
     * 
     * @type {number}
     * @memberof CourierResolver
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CourierResolver
     */
    courierId?: number;
}

/**
 * Check if a given object implements the CourierResolver interface.
 */
export function instanceOfCourierResolver(value: object): value is CourierResolver {
    return true;
}

export function CourierResolverFromJSON(json: any): CourierResolver {
    return CourierResolverFromJSONTyped(json, false);
}

export function CourierResolverFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierResolver {
    if (json == null) {
        return json;
    }
    return {
        
        'realm': json['realm'] == null ? undefined : json['realm'],
        'adminUrl': json['adminUrl'] == null ? undefined : json['adminUrl'],
        'customerUrl': json['customerUrl'] == null ? undefined : json['customerUrl'],
        'marketingUrl': json['marketingUrl'] == null ? undefined : json['marketingUrl'],
        'passkeyRpId': json['passkeyRpId'] == null ? undefined : json['passkeyRpId'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function CourierResolverToJSON(json: any): CourierResolver {
    return CourierResolverToJSONTyped(json, false);
}

export function CourierResolverToJSONTyped(value?: CourierResolver | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realm': value['realm'],
        'adminUrl': value['adminUrl'],
        'customerUrl': value['customerUrl'],
        'marketingUrl': value['marketingUrl'],
        'passkeyRpId': value['passkeyRpId'],
        'id': value['id'],
        'courierId': value['courierId'],
    };
}

